import React,{useState,useEffect}from 'react';
import styled from 'styled-components';
import TitleHeader from 'components/presenters/header/TitleHeader';
import GroupFriend from '../components/peoplelist/GroupFriend';
import BottomModalVar3 from '../components/modal/Bottom_Modal_var3'
import serverController from '../server/serverController'
import { useSelector } from 'react-redux';

// 하단 모달 창 리스트 
let modallist = [
  {
      text:"강제퇴장",
      color:"#de0000",
      // clickEvent: ()=>{
      //     alert("확인");
      // }
  }
]




export default function Groupmenberlist({match}) {
  const userInfo = useSelector(state=>{ return state.userInfo}); 
  const [currentPostIndex , setCurrentPostIndex] = useState(0);
  
  const [isLoading, setIsLoading] = useState(false);
  const [isEnd, setIsEnd] = useState(false);
  const [lastNumber , setLastNumber] = useState(null);

  // 프로젝트 참여인원
  const [peoplelist , setPeopLeList] = useState([]);
  const memberCallBack=(res)=>{
    if(res.success !== 1){
      alert("예기치 못한 문제가 발생하였습니다.");
      return;
    }

    let jsonData = res.data;
    let memberList = jsonData.members
    if(memberList.length === 0)
    {
      setIsEnd(true);
    }
    else
    {

      setPeopLeList([...peoplelist, ...memberList]);
      setLastNumber(memberList[memberList.length-1][['no']]);
    }

    setIsLoading(false);

  }
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    serverController.getServerData(`groups/${match.params.id}/members`,memberCallBack);
  },[]);




  // 그룹상세
  const [groupInfo , setGroupInfo] = useState({});
  const infoCallBack=(jsonData)=>{
    if(jsonData.success !== 1){
      alert("예기치 못한 문제가 발생하였습니다.");
      return;
    }
    setGroupInfo(jsonData.data);
  }
  useEffect(() => {
    serverController.getServerData(`groups/${match.params.id}`,infoCallBack);
  },[]);

  //참여인원 강퇴하기
  const delcallBack  = (res) =>{
    if(res.success === 1){
        alert("성공")
        // window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("실패")
    }
  }

  const handleScroll = (e) => {
      if(!isEnd && !isLoading)
      {
          const bottom = (e.target.scrollHeight - e.target.scrollTop - 100) <= e.target.clientHeight;
          if (bottom) { 
            setIsLoading(true);
            serverController.getServerData(`groups/${match.params.id}/members?last_pos_no=${lastNumber}`,memberCallBack);
          }
      }
  }
  
  /*--click block--*/
  var isclick = false;
  const delmemberSubmit = async ()=>{
      if(isclick)
          return;
      isclick = true;

      let data = {};
      await serverController.insertFilePostFetchController(`groups/${match.params.id}/members/${currentPostIndex}/block`,JSON.stringify(data),delcallBack);
      isclick = false;
  }


  //친구신청 하기
  const friendSubmitcallBack  = (res) =>{
    if(res.success === 1){
        // alert("성공")
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("실패")
    }
  }

  /*--click block--*/
  const friendSubmit= async (indexOptional)=> {
      if(isclick)
         return;
      isclick = true;

      var postIndex = indexOptional ? indexOptional : currentPostIndex
      let data = {};

      await serverController.insertFilePostFetchController(`friends/users/${postIndex}/requests`, JSON.stringify(data), friendSubmitcallBack);
      isclick = false;
  }

  // 친구신청 취소하기
  const friendsdeleteCallBack  = (res) =>{
      if(res.success === 1){
          window.location.reload();
          //serverController.getServerData("auth",test);
      }else {
          alert("실패")
      }
    }

    /*--click block--*/
    const frienddeleteSubmit= async (indexOptional)=> {
      if(isclick)
          return;
      isclick = true;
      let data = {};
      await serverController.updateFileDeleteFetchController(`friends/users/${currentPostIndex}/requests`,JSON.stringify(data),friendsdeleteCallBack);
      isclick = false;
  }

  // 친구 삭제하기
  const friendsdelCallBack  = (res) =>{
    if(res.success === 1){
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("실패")
    }
  }

  /*--click block--*/
  const friendDelSubmit=async ()=> {
    if(isclick)
        return;
    isclick = true;
    
    let data = {};
    await serverController.updateFileDeleteFetchController(`friends/users/${currentPostIndex}`,JSON.stringify(data),friendsdelCallBack);
    isclick = false;
  }

  //친구신청 수락 하기
  const submitcallBack  = (res) =>{
    if(res.success === 1){
        // alert("성공")
        window.location.reload();
        //serverController.getServerData("auth",test);
    }else {
        alert("실패")
    }
  }

  /*--click block--*/
  const dataSubmit= async (indexOptional)=> {
      if(isclick)
         return;
      isclick = true;

      var postIndex = indexOptional ? indexOptional : currentPostIndex
      let data = {};

      await serverController.insertFilePostFetchController(`friends/users/${postIndex}/requests/result`, JSON.stringify(data), submitcallBack);
      isclick = false;
  }


 

  const [modalShow,setModalShow] = useState(false); 
  const [modalOption ,setModalOption] = useState("");
 


  const openModalExit = () => {
    modallist[0].clickEvent = () =>{ 
      setModalShow(false);
      // setCurrentPostIndex(userNo)
    };
  }

  openModalExit();

  const clickSelector =  {
    "forcedExit" : [
        () => { setModalShow(false); delmemberSubmit(currentPostIndex); setModalOption("");},
    ],
    "friendcancel" : [
      () => { setModalShow(false); friendDelSubmit(currentPostIndex); setModalOption("");},
    ],
    "requestCancel" : [
      () => { setModalShow(false); frienddeleteSubmit(currentPostIndex); setModalOption("");},
    ],
  };

  return (
    <div className="PeopleList">
      <TitleHeader title={"참여인원"}  borderbottom={'1px solid #d5d5d5'}/>
      <FriendListInner onScroll={handleScroll}>
      {
        peoplelist.map((value ,index)=>{
          return  <GroupFriend 
                    key={`group-member-list-item-${value['no']}`}
                    display={"block"} 
                    nickname={value.nickname}  
                    index={index}
                    // openModal={openModal}
                    value={value}
                    userInfo={userInfo}
                    groupInfo={groupInfo}
                    currentPostIndex={currentPostIndex}
                    setCurrentPostIndex={setCurrentPostIndex}
                    setModalOption={setModalOption}
                    setModalShow={setModalShow}
                    friendSubmit={friendSubmit}
                    frienddeleteSubmit={frienddeleteSubmit}
                    dataSubmit={dataSubmit}
             
                  />
        })
      }
      </FriendListInner> 

      {/* 모달 버전들  */}
      <BottomModalVar3 
        modalShow={modalShow}    //모달 보여지는 여부
        setModalShow={setModalShow} 
        modalOption={modalOption}
        clickEventList={clickSelector[modalOption]}
        setModalOption={setModalOption}
        // currentPostIndex={currentPostIndex}
    />

    </div>


  );
}


const FriendListInner = styled.div`
  overflow-y: scroll;
  height: 100vh;
  padding-top: calc(100vw*(73.5/375));
`

